import {useContext} from 'react';
import {ThemeContext} from '../../utils/ThemeContext';

const PartnersHeroSvg1 = () => {
  const {theme} = useContext(ThemeContext);
  const linearGradientID = theme === 'dark' ? 'url(#paint0)' : 'url(#paint1)';

  const svgContainerStyle = {
    position: 'absolute',
    left: 'calc(50% - 500px)',
    top: 'calc(50% - 15px)',
    width: '114',
    height: '238'
  };
  const pathStyle = {
    strokeDasharray: '1200',
    strokeDashoffset: '1200',
    animation: 'draw 2s ease-in-out forwards',
    animationDelay: '1s',
    stroke: linearGradientID,
    strokeWidth: '2',
    strokeLinecap: 'round'
  };

  return (
    <div style={svgContainerStyle}>
      <svg width='114' height='238' viewBox='0 0 114 238' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M113 237C47.4183 182.538 1 100.392 0.999996 1' style={pathStyle} />
        <defs>
          <linearGradient id='paint0' x1='-12.2015' y1='74.5231' x2='118.691' y2='257.882' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#2463AC' />
            <stop offset='1' stopColor='#A3CDFF' stopOpacity='0' />
          </linearGradient>
          <linearGradient id='paint1' x1='11.5' y1='-64.5' x2='126.934' y2='258.792' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#FE7518' />
            <stop offset='1' stopColor='#FE7518' stopOpacity='0' />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default PartnersHeroSvg1;

